import { Validators, ValidatorFn } from '@angular/forms';

export class FormInfo {
  validators: Validators;
  disabled: boolean;
  constructor(required: boolean, validator: Validators) {
    this.disabled = required;
    this.validators = validator;
  }
}
export const SITEVALIDATORS = {
    CREATE: new Map<string, FormInfo>([
      ['id', new FormInfo(false, [])],
      ['dCreation', new FormInfo(true, [])],
      ['idCreateur', new FormInfo(true, [])],
      ['dModification', new FormInfo(true, [])],
      ['idModifieur', new FormInfo(true, [])],
      ['dDesactivation', new FormInfo(true, [])],
      ['code', new FormInfo(false, [Validators.required, Validators.maxLength(2)])],
      ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(30)])],
      ['idSociete', new FormInfo(false, [])],
      ['rSociale', new FormInfo(false, [Validators.maxLength(30)])],
      ['adr1', new FormInfo(false, [Validators.max(70)])],
      ['adr2', new FormInfo(false, [Validators.maxLength(70)])],
      ['adr3', new FormInfo(false, [Validators.maxLength(70)])],
      ['adrFact1', new FormInfo(false, [Validators.maxLength(70)])],
      ['adrFact2', new FormInfo(false, [Validators.maxLength(70)])],
      ['adrFact3', new FormInfo(false, [Validators.maxLength(70)])],
      ['tel', new FormInfo(false, [Validators.maxLength(30)])],
      ['fax', new FormInfo(false, [Validators.maxLength(30)])],
      ['type', new FormInfo(false, [Validators.required, Validators.maxLength(1)])],
      ['ca1', new FormInfo(false, [])],
      ['siret1', new FormInfo(false, [Validators.maxLength(9)])],
      ['siret2', new FormInfo(false, [Validators.maxLength(5)])],
      ['naf', new FormInfo(false, [Validators.maxLength(5)])],
      ['email', new FormInfo(false, [Validators.maxLength(255)])]
    ]),
    EDIT: new Map<string, FormInfo>([
      ['id', new FormInfo(false, [])],
      ['dCreation', new FormInfo(true, [])],
      ['idCreateur', new FormInfo(true, [])],
      ['dModification', new FormInfo(true, [])],
      ['idModifieur', new FormInfo(true, [])],
      ['dDesactivation', new FormInfo(true, [])],
      ['code', new FormInfo(true, [Validators.required, Validators.maxLength(2)])],
      ['libelle', new FormInfo(false, [Validators.required, Validators.maxLength(30)])],
      ['idSociete', new FormInfo(false, [])],
      ['rSociale', new FormInfo(false, [Validators.maxLength(30)])],
      ['adr1', new FormInfo(false, [Validators.maxLength(70)])],
      ['adr2', new FormInfo(false, [Validators.maxLength(70)])],
      ['adr3', new FormInfo(false, [Validators.maxLength(70)])],
      ['adrFact1', new FormInfo(false, [Validators.maxLength(70)])],
      ['adrFact2', new FormInfo(false, [Validators.maxLength(70)])],
      ['adrFact3', new FormInfo(false, [Validators.maxLength(70)])],
      ['tel', new FormInfo(false, [Validators.maxLength(30)])],
      ['fax', new FormInfo(false, [Validators.maxLength(30)])],
      ['type', new FormInfo(false, [Validators.required, Validators.maxLength(1)])],
      ['ca1', new FormInfo(false, [])],
      ['siret1', new FormInfo(false, [Validators.maxLength(9)])],
      ['siret2', new FormInfo(false, [Validators.maxLength(5)])],
      ['naf', new FormInfo(false, [Validators.maxLength(5)])],
      ['email', new FormInfo(false, [Validators.maxLength(255)])]
    ]),
    VISUALIZE: new Map<string, FormInfo>([
      ['id', new FormInfo(false, [])],
      ['dCreation', new FormInfo(true, [])],
      ['idCreateur', new FormInfo(true, [])],
      ['dModification', new FormInfo(true, [])],
      ['idModifieur', new FormInfo(true, [])],
      ['dDesactivation', new FormInfo(true, [])],
      ['code', new FormInfo(true, [Validators.required])],
      ['libelle', new FormInfo(true, [Validators.required])],
      ['idSociete', new FormInfo(true, [])],
      ['rSociale', new FormInfo(true, [])],
      ['adr1', new FormInfo(true, [])],
      ['adr2', new FormInfo(true, [])],
      ['adr3', new FormInfo(true, [])],
      ['adrFact1', new FormInfo(true, [])],
      ['adrFact2', new FormInfo(true, [])],
      ['adrFact3', new FormInfo(true, [])],
      ['tel', new FormInfo(true, [])],
      ['fax', new FormInfo(true, [])],
      ['type', new FormInfo(true, [Validators.required])],
      ['ca1', new FormInfo(true, [])],
      ['siret1', new FormInfo(true, [])],
      ['siret2', new FormInfo(true, [])],
      ['naf', new FormInfo(true, [])],
      ['email', new FormInfo(true, [])]
    ])
  };
